import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  tab:{
    fontSize:15,
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize:10,
 
    },
},
  box:{
    borderBottom: 1, borderColor: 'divider' ,
    // display:"flex",justifyContent:"center",
    // [theme.breakpoints.between('xs', 'md')]: {
        
   
    //   },
  }
}));

